import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/kit';

export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Something went wrong loading this page.';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <AlertTriangle className="h-8 w-8 text-destructive" aria-hidden />
      <div>
        <h1 className="font-display text-xl font-semibold">This page could not be loaded</h1>
        <p className="id-mono mt-1 text-sm text-muted-foreground">{message}</p>
      </div>
      <div className="flex gap-2">
        <Button variant="primary" onClick={() => navigate('/registry')}>Back to Capabilities</Button>
        <Button onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
}
